import { RootState } from 'store';
import { TIsLoading } from 'common/types/common';

import { STATE } from '../types/state';
import { StatusLoading } from 'common/constants';

export const useIsStationsLoading = (state: RootState) => {
  const {
    stations: { isLoading },
  } = state[STATE];
  return isLoading === StatusLoading.Load;
};
